import { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import SessionStatus from 'components/SessionStatus';
import api from 'utils/api';
import { clearAuth, hasAdminAccess, useAuth } from 'utils/auth';
import ErrorSnackbar from './ErrorSnackbar';
import { errorMessage } from './state';
import { useSetRecoilState } from 'recoil';

export default function NusSignIn() {
  const auth = useAuth();
  const navigate = useNavigate();
  const setError = useSetRecoilState(errorMessage);
  useEffect(() => {
    if (hasAdminAccess(auth.user)) navigate('/', { replace: true });
  }, [auth.user, navigate]);

  const signOut = async () => {
    try {
      if (auth.session) await api.post('/public/oidc/logout');
      clearAuth();
      navigate('/login');
    } catch {
      setError('Unable to end your session. Please try again.');
    }
  };

  if (!auth.ready) return <SessionStatus />;
  return (
    <Container maxWidth={false} sx={{ py: 6, maxWidth: 600 }}>
      <Alert severity='error'>
        {auth.session
          ? 'You do not have permission to access this website. Contact an administrator for access.'
          : 'Your NUS sign-in has expired. Please log in again.'}
      </Alert>
      <Button onClick={signOut}>Back to login</Button>
      <ErrorSnackbar />
    </Container>
  );
}
